'use client';

import Image from '@eliadmin/core/src/components/image/image-wrapped';
import Link from '@eliadmin/core/src/components/link';

import { Button } from '../../ui/button';

import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { useGlobalStore } from '@eliadmin/core/src/stores/global-store';

export function AgentCard() {
  const { t } = useTranslations();
  const generalLayout = useGlobalStore(state => state.generalLayout);

  return (
    <div className="flex w-full flex-col items-start justify-start gap-4 rounded-[20px] border border-black/5 p-4 sm:max-w-[397px] sm:gap-5 sm:p-5 lg:gap-6 lg:p-6">
      <Image
        src={'/images/agent.png'}
        alt="Agent"
        width={76}
        height={76}
        className="h-full max-h-[76px] min-h-[76px] w-full min-w-[76px] max-w-[76px] overflow-hidden rounded-full object-cover"
      />
      <div className="flex w-full flex-col gap-2">
        <p className="text-xl font-medium lg:text-2xl">{t('text611')}</p>
        <p className="text-sm">{t('text2358')}</p>
      </div>
      <Button asChild>
        <Link
          prefetch={false}
          href={`tel:${generalLayout.contact?.phone}`}
          target="_blank"
          rel="noreferrer"
        >
          {t('text1153')}
        </Link>
      </Button>
    </div>
  );
}
